import ServiceCategoryPage from "../components/ServiceCategoryPage";
import washingMachineRepairService from "../data/services/washingMachineRepairService";

function WashingMachineRepair() {
  return <ServiceCategoryPage service={washingMachineRepairService} />;
}

export default WashingMachineRepair;